import { Directive } from '@angular/core';

@Directive({ selector: '[appTableCellTemplate]' })
export class TableCellTemplateDirective { }
